import React from 'react';
import Select from 'react-select';

const SelectWithSearch = ({
  options = [],
  defaultValue = null,
  isClearable = true,
  isSearchable = true,
  isDisabled = false,
  isLoading = false,
  isRtl = false,
  onChange,
  name = 'react-select',
  placeholder = 'Select SKU'
}) => {
  return (
    <Select
      className="basic-single"
      classNamePrefix="select"
      defaultValue={defaultValue}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isClearable={isClearable}
      isRtl={isRtl}
      isSearchable={isSearchable}
      name={name}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default SelectWithSearch;
